export default "__VITE_ASSET__552e8fb1__"